<style scoped>
.title-form{
    text-align: right;
  }
@media only screen and (max-width: 600px) {
  .title-form{
    text-align: left;
  }
  .btn-add-baru{
    width: 100%;
  }

  .title-add-baru{
    text-align: center;
  }
}
.title {
  margin-bottom: 0rem;
  font-size: 0.75rem;
}
.sub-title {
  font-weight: 600;
}
</style>
<template>
  <b-container fluid class="content landing-page">
    <b-breadcrumb :items="breadcrumbs" class="breadcrumbs"></b-breadcrumb>
    <b-container fluid>
      <title-page
        :title="'Entri Hasil Ground Chek'"
        :subtitle="'Lakukan penginputan data berdasarkan isian hasil ground check anomali.'"
      />
      <div class="table-responsive" v-if="datas.length > 0">
        <b-row class="mt-2">
          <b-col lg="2" md="4" sm="12">
            <p class="title">Provinsi:</p>
            <p class="sub-title">{{ datas[0].nama_prov }}</p>
          </b-col>
          <b-col lg="2" md="4" sm="12">
            <p class="title">Kabupaten/Kota:</p>
            <p class="sub-title">{{ datas[0].nama_kab }}</p>
          </b-col>
          <b-col lg="2" md="4" sm="12">
            <p class="title">Kecamatan:</p>
            <p class="sub-title">{{ datas[0].nama_kec }}</p>
          </b-col>
          <b-col lg="2" md="4" sm="12">
            <p class="title">Desa/Kelurahan:</p>
            <p class="sub-title">{{ datas[0].nama_desa }}</p>
          </b-col>
          <b-col lg="2" md="4" sm="12">
            <p class="title">SLS:</p>
            <p class="sub-title">{{ datas[0].nama_sls }}</p>
          </b-col>
          <b-col lg="2" md="4" sm="12">
            <p class="title">Nomor KK:</p>
            <p class="sub-title">{{ datas[0].nomor_kk }}</p>
          </b-col>
        </b-row>
        <b-table
          v-if="datas.length > 0"
          class="table table-primary"
          :items="datas"
          :fields="fields"
          bordered
          striped
          hover
        >
          <template v-slot:cell(no)="data"> {{ data.index + 1 }}. </template>
          <template v-slot:cell(jumlah_anomali)="data">
            {{ countAnomali(data.item) }}
          </template>
          <template v-slot:cell(jenis_kelamin)="data">
            {{ masters.jenis_kelamin[data.item.jenis_kelamin] }}
          </template>
          <template v-slot:cell(status_hubungan_keluarga)="data">
            {{
              masters.status_hubungan_keluarga[
                data.item.status_hubungan_keluarga
              ]
            }}
          </template>
          <template v-slot:cell(status)="data">
            {{ cekHistory(data.item.id) }}
          </template>
          <template v-slot:cell(aksi)="data">
            <div class="text-center">
              <b-btn
                v-if="cekHistory(data.item.id) == 'Belum Dikonfirmasi'"
                @click="konfirmasi(1, data.item)"
                class="ml-1 btn btn-sm btn-success"
                >Konfirmasi</b-btn
              >
              <template v-else>
                <b-btn
                  class="ml-1 btn btn-sm btn-warning"
                  @click="konfirmasi(2, data.item)"
                  >Ubah</b-btn
                >
                <b-btn
                  class="ml-1 btn btn-sm btn-danger"
                  @click="deleteHistoryData(data.item.id)"
                  >Hapus</b-btn
                >
              </template>
            </div>
          </template>
        </b-table>
      </div>
      <div class="mt-4">
        <b-row>
          <b-col class="text-left" lg="8" md="8" sm="12">
            <legend class="title-add-baru">Daftar Anggota Keluarga Tambahan</legend>
          </b-col>
          <b-col class="text-right" lg="4" md="4" sm="12">
            <b-button class="btn-add-baru" variant="primary" @click="showModal(1, null)"
              >Tambah Baru</b-button
            >
          </b-col>
        </b-row>
        <div class="table-responsive">
          <b-table
            show-empty
            class="table table-primary"
            :items="tambahanDatas"
            :fields="tambahanFields"
            bordered
            striped
            hover
          >
            <template v-slot:cell(no)="data"> {{ data.index + 1 }}. </template>
            <template v-slot:cell(jenis_kelamin)="data">
              {{ masters.jenis_kelamin[data.item.jenis_kelamin] }}
            </template>
            <template v-slot:cell(tanggal_lahir)="data">
              {{ data.item.tanggal_lahir | formatDate }}
            </template>
            <template v-slot:cell(agama)="data">
              {{ masters.agama[data.item.agama] }}
            </template>
            <template v-slot:cell(pendidikan)="data">
              {{ masters.pendidikan[data.item.pendidikan] }}
            </template>
            <template v-slot:cell(status_kawin)="data">
              {{ masters.status_pernikahan[data.item.status_kawin] }}
            </template>
            <template v-slot:cell(status_hubungan_keluarga)="data">
              {{
                masters.status_hubungan_keluarga[
                  data.item.status_hubungan_keluarga
                ]
              }}
            </template>
            <template v-slot:cell(aksi)="data">
              <b-btn
                class="ml-1 btn btn-sm btn-warning"
                @click="showModal(2, data.item)"
                >Ubah</b-btn
              >
              <b-btn
                class="ml-1 btn btn-sm btn-danger"
                @click="deleteTambahanData({ id: data.item.id })"
                >Hapus</b-btn
              >
            </template>
          </b-table>
        </div>
      </div>
      <div id="div-form">
        <b-row v-if="itemSelected">
          <b-col lg="5" md="12" sm="12">
            <b-card>
              <legend>Keterangan Individu</legend>
              <table class="w-100">
                <tr>
                  <td>Nama Lengkap</td>
                  <td style="padding: 0 10px">:</td>
                  <td>{{ itemSelected.nama }}</td>
                  <td class="text-right">
                    <b-form-checkbox
                      v-if="form.status_keberadaan == 1"
                      v-model="form.nama"
                      value="1"
                      unchecked-value="0"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Nomor Induk Kependudukan</td>
                  <td style="padding: 0 10px">:</td>
                  <td>{{ itemSelected.nik }}</td>
                  <td class="text-right">
                    <b-form-checkbox
                      v-if="form.status_keberadaan == 1"
                      v-model="form.nik"
                      value="1"
                      unchecked-value="0"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Nomor Kartu Keluarga</td>
                  <td style="padding: 0 10px">:</td>
                  <td>{{ itemSelected.nomor_kk }}</td>
                  <td class="text-right">
                    <b-form-checkbox
                      v-if="form.status_keberadaan == 1"
                      v-model="form.nomor_kk"
                      value="1"
                      unchecked-value="0"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Jenis Kelamin</td>
                  <td style="padding: 0 10px">:</td>
                  <td>
                    {{ masters.jenis_kelamin[itemSelected.jenis_kelamin] }}
                  </td>
                  <td class="text-right">
                    <b-form-checkbox
                      v-if="form.status_keberadaan == 1"
                      v-model="form.jenis_kelamin"
                      value="1"
                      unchecked-value="0"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Tanggal Lahir</td>
                  <td style="padding: 0 10px">:</td>
                  <td>{{ itemSelected.tanggal_lahir }}</td>
                  <td class="text-right">
                    <b-form-checkbox
                      v-if="form.status_keberadaan == 1"
                      v-model="form.tanggal_lahir"
                      value="1"
                      unchecked-value="0"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Agama</td>
                  <td style="padding: 0 10px">:</td>
                  <td>{{ masters.agama[itemSelected.agama] }}</td>
                  <td class="text-right">
                    <b-form-checkbox
                      v-if="form.status_keberadaan == 1"
                      v-model="form.agama"
                      value="1"
                      unchecked-value="0"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Pendidikan</td>
                  <td style="padding: 0 10px">:</td>
                  <td>{{ masters.pendidikan[itemSelected.pendidikan] }}</td>
                  <td class="text-right">
                    <b-form-checkbox
                      v-if="form.status_keberadaan == 1"
                      v-model="form.pendidikan"
                      value="1"
                      unchecked-value="0"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Jenis Pekerjaan:</td>
                  <td style="padding: 0 10px">:</td>
                  <td>{{ itemSelected.pekerjaan }}</td>
                  <td class="text-right">
                    <b-form-checkbox
                      v-if="form.status_keberadaan == 1"
                      v-model="form.pekerjaan"
                      value="1"
                      unchecked-value="0"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Status Pernikahan</td>
                  <td style="padding: 0 10px">:</td>
                  <td>
                    {{ masters.status_pernikahan[itemSelected.status_kawin] }}
                  </td>
                  <td class="text-right">
                    <b-form-checkbox
                      v-if="form.status_keberadaan == 1"
                      v-model="form.status_kawin"
                      value="1"
                      unchecked-value="0"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Status Hubungan Dalam keluarga</td>
                  <td style="padding: 0 10px">:</td>
                  <td>
                    {{
                      masters.status_hubungan_keluarga[
                        itemSelected.status_hubungan_keluarga
                      ]
                    }}
                  </td>
                  <td class="text-right">
                    <b-form-checkbox
                      v-if="form.status_keberadaan == 1"
                      v-model="form.status_hubungan_keluarga"
                      value="1"
                      unchecked-value="0"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Kewarganegaraan</td>
                  <td style="padding: 0 10px">:</td>
                  <td>
                    {{
                      itemSelected.kewarganegaraan == 0
                        ? "Warga Negara Indonesia"
                        : "Warga Negara Asing"
                    }}
                  </td>
                  <td class="text-right">
                    <b-form-checkbox
                      v-if="form.status_keberadaan == 1"
                      v-model="form.kewarganegaraan"
                      value="1"
                      unchecked-value="0"
                    />
                  </td>
                </tr>
              </table>
              <legend class="mt-2">Daftar Anomali</legend>
              <ul>
                <li v-if="itemSelected.rule1 == 1">
                  Nomor Induk Kependudukan Tidak Valid
                </li>
                <li v-if="itemSelected.rule2 == 1">
                  Nomor Kartu Keluarga Tidak Valid
                </li>
                <li v-if="itemSelected.rule3 == 1">
                  Alamat domisili pada SP2020 tidak sesuai dengan alamat di
                  KK/KTP
                </li>
                <li v-if="itemSelected.rule4 == 1">
                  Jenis kelamin di SP 2020 berbeda dengan jenis kelamin di
                  Dukcapil
                </li>
                <li v-if="itemSelected.rule5 == 1">
                  Umur kurang dari 11 tahun tetapi sebagai Kepala Keluarga
                </li>
                <li v-if="itemSelected.rule6 == 1">
                  Anggota keluarga hanya 1, tetapi status sebagai anak/istri/dll
                </li>
                <li v-if="itemSelected.rule7 == 1">
                  Sumber perlu dikonfirmasi
                </li>
              </ul>
            </b-card>
          </b-col>
          <b-col lg="7" md="12" sm="12">
            <b-card>
              <legend>Hasil Ground Check</legend>
              <BSelectWithValidation
                v-model="form.status_keberadaan"
                name="Status Keberadaan"
              >
                <option value="">Pilih Status Keberadaan</option>
                <option value="1">Ditemukan</option>
                <option value="2">Tidak Ditemukan</option>
                <option value="3">Pindah</option>
                <option value="4">Meninggal</option>
              </BSelectWithValidation>
              <div v-if="form.status_keberadaan == 1">
                <b-alert show variant="info"
                  >Klik pada kotak jika isian atribut individu sudah
                  benar/sesuai dengan kondisi saat ini.</b-alert
                >
                <ValidationObserver v-slot="{ passes }">
                  <b-row class="my-1" v-if="form.nama == 0">
                    <b-col sm="3" class="title-form"> Nama </b-col>
                    <b-col sm="9">
                      <BTextInputWithValidation
                        rules="required"
                        v-model="form.data.nama"
                        name="Nama"
                        placeholder="Isikan nama hasil ground check"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="my-1" v-if="form.nik == 0">
                    <b-col sm="3" class="title-form">
                      Nomor Induk Kependudukan
                    </b-col>
                    <b-col sm="9">
                      <BTextInputWithValidation
                        rules="required|digits:16"
                        type="number"
                        v-model="form.data.nik"
                        name="Nomor Induk Kependudukan"
                        label=""
                        placeholder="Isikan nomor induk kependudukan hasil ground check"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="my-1" v-if="form.nomor_kk == 0">
                    <b-col sm="3" class="title-form">
                      Nomor Kartu Keluarga
                    </b-col>
                    <b-col sm="9">
                      <BTextInputWithValidation
                        v-model="form.data.nomor_kk"
                        rules="required|digits:16"
                        type="number"
                        name="Nomor Kartu Keluarga"
                        placeholder="Isikan nomor kartu keluarga hasil ground check"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="my-1" v-if="form.jenis_kelamin == 0">
                    <b-col sm="3" class="title-form"> Jenis Kelamin </b-col>
                    <b-col sm="9">
                      <BRadioWithValidation
                        rules="required"
                        v-model="form.data.jenis_kelamin"
                        name="Jenis Kelamin"
                        placeholder="Isikan jenis kelamin hasil ground check"
                      >
                        <b-form-radio value="L">Laki-laki</b-form-radio>
                        <b-form-radio value="P">Perempuan</b-form-radio>
                      </BRadioWithValidation>
                    </b-col>
                  </b-row>
                  <b-row class="my-1" v-if="form.tanggal_lahir == 0">
                    <b-col sm="3" class="title-form"> Tanggal Lahir </b-col>
                    <b-col sm="9">
                      <BDatePickerWithValidation
                        rules="required"
                        v-model="form.data.tanggal_lahir"
                        name="Tanggal Lahir"
                        placeholder="Isikan tanggal lahir hasil ground check"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="my-1" v-if="form.agama == 0">
                    <b-col sm="3" class="title-form"> Agama </b-col>
                    <b-col sm="9">
                      <BSelectWithValidation
                        rules="required"
                        v-model="form.data.agama"
                        name="Agama"
                        placeholder="Isikan agama hasil ground check"
                      >
                        <option value="">Pilih Agama</option>
                        <option value="1">Islam</option>
                        <option value="2">Kristen</option>
                        <option value="3">Katholik</option>
                        <option value="4">Hindu</option>
                        <option value="5">Budha</option>
                        <option value="6">Konghuchu</option>
                        <option value="7">Aliran Kepercayaan</option>
                      </BSelectWithValidation>
                    </b-col>
                  </b-row>
                  <b-row class="my-1" v-if="form.pendidikan == 0">
                    <b-col sm="3" class="title-form">
                      Pendidikan Terakhir
                    </b-col>
                    <b-col sm="9">
                      <BSelectWithValidation
                        rules="required"
                        v-model="form.data.pendidikan"
                        name="Pendidikan Terakhir"
                        placeholder="Isikan pendidikan terakhir hasil ground check"
                      >
                        <option value="">Pilih Pendidikan Terakhir</option>
                        <option value="1">Tidak/Belum Sekolah</option>
                        <option value="2">Belum Tamat SD/Sederajat</option>
                        <option value="3">Tamat SD/Sederajat</option>
                        <option value="4">SLTP/Sederajat</option>
                        <option value="5">SLTA/Sederajat</option>
                        <option value="6">Diploma I/II</option>
                        <option value="7">
                          Akademi/Diploma III/Sarjana Muda
                        </option>
                        <option value="8">Diploma IV/Strata I</option>
                        <option value="9">Strata II</option>
                        <option value="10">Strata III</option>
                      </BSelectWithValidation>
                    </b-col>
                  </b-row>
                  <b-row class="my-1" v-if="form.pekerjaan == 0">
                    <b-col sm="3" class="title-form"> Pekerjaan </b-col>
                    <b-col sm="9">
                      <BTextInputWithValidation
                        rules="required"
                        v-model="form.data.pekerjaan"
                        name="Pekerjaan"
                        placeholder="Isikan pekerjaan hasil ground check"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="my-1" v-if="form.status_kawin == 0">
                    <b-col sm="3" class="title-form"> Status Pernikahan </b-col>
                    <b-col sm="9">
                      <BRadioWithValidation
                        rules="required"
                        v-model="form.data.status_kawin"
                        name="Status Pernikahan"
                        placeholder="Isikan status pernikahan ground check"
                      >
                        <b-form-radio value="1">Belum Kawin</b-form-radio>
                        <b-form-radio value="2">Kawin</b-form-radio>
                        <b-form-radio value="3">Cerai Hidup</b-form-radio>
                        <b-form-radio value="4">Cerai Mati</b-form-radio>
                      </BRadioWithValidation>
                    </b-col>
                  </b-row>
                  <b-row class="my-1" v-if="form.status_hubungan_keluarga == 0">
                    <b-col sm="3" class="title-form">
                      Status Hungan Dengan Keluarga
                    </b-col>
                    <b-col sm="9">
                      <BSelectWithValidation
                        rules="required"
                        v-model="form.data.status_hubungan_keluarga"
                        name="Status Hubungan Dalam Keluarga"
                        placeholder="Isikan status hubungan dalam keluarga hasil ground check"
                      >
                        <option value="">
                          Pilih Status Hubungan Dalam Keluarga
                        </option>
                        <option value="1">Kepala Keluarga</option>
                        <option value="2">Suami</option>
                        <option value="3">Istri</option>
                        <option value="4">Anak</option>
                        <option value="5">Orang Tua</option>
                        <option value="6">Mertua</option>
                        <option value="7">Menantu</option>
                        <option value="8">Cucu</option>
                        <option value="9">Pembantu</option>
                        <option value="10">Famili Lain</option>
                        <option value="11">Lainnya</option>
                      </BSelectWithValidation>
                    </b-col>
                  </b-row>
                  <b-row class="my-1" v-if="form.kewarganegaraan == 0">
                    <b-col sm="3" class="title-form"> Kewarganegaraan </b-col>
                    <b-col sm="9">
                      <BRadioWithValidation
                        rules="required"
                        v-model="form.data.kewarganegaraan"
                        name="Kewarganegaraan"
                        placeholder="Isikan kewarganegaraan hasil ground check"
                      >
                        <b-form-radio value="0"
                          >Warga Negara Indonesia</b-form-radio
                        >
                        <b-form-radio value="1"
                          >Warga Negara Asing</b-form-radio
                        >
                      </BRadioWithValidation>
                    </b-col>
                  </b-row>
                  <b-button
                    v-if="konfirmasiButton == 'tambah'"
                    variant="success"
                    class="float-right"
                    @click="passes(simpan)"
                    >Simpan</b-button
                  >
                  <b-button
                    v-else
                    variant="warning"
                    class="float-right"
                    @click="passes(ubah)"
                    >Ubah</b-button
                  >
                </ValidationObserver>
              </div>
              <div v-if="form.status_keberadaan == 2">
                <b-alert show variant="info"
                  >Klik simpan tombol simpan untuk menyimpan hasil ground check
                  dengan status keberadaan tidak ditemukan.</b-alert
                >
                <b-button
                  variant="success"
                  class="float-right"
                  @click="simpan()"
                  >Simpan</b-button
                >
              </div>
              <div v-if="form.status_keberadaan == 3">
                <b-alert show variant="info"
                  >Isikan keterangan anggota keluarga pindah.</b-alert
                >
                <b-row class="my-1">
                  <b-col sm="3" class="title-form"> Provinsi </b-col>
                  <b-col sm="9">
                    <BSelectWithValidation
                      v-model="form.data.kode_prov"
                      name="Provinsi"
                    >
                      <option value="">Pilih Provinsi</option>
                      <option
                        v-for="item in provinsis"
                        :value="item.kode_prov"
                        v-bind:key="item.kode_prov"
                      >
                        {{ item.nama_prov }}
                      </option>
                    </BSelectWithValidation>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="3" class="title-form"> Kabupaten/Kota </b-col>
                  <b-col sm="9">
                    <BSelectWithValidation
                      v-model="form.data.kode_kab"
                      name="Kabupaten/kota"
                    >
                      <option value="">Pilih Kabupaten/Kota</option>
                      <option
                        v-for="item in kabupatenKotas"
                        :value="item.kode_kab"
                        v-bind:key="item.kode_kab"
                      >
                        {{ item.nama_kab }}
                      </option>
                    </BSelectWithValidation>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="3" class="title-form"> Kecamatan </b-col>
                  <b-col sm="9">
                    <BSelectWithValidation
                      v-model="form.data.kode_kec"
                      name="Kecamatan"
                    >
                      <option value="">Pilih Kecamatan</option>
                      <option
                        v-for="item in kecamatans"
                        :value="item.kode_kec"
                        v-bind:key="item.kode_kec"
                      >
                        {{ item.nama_kec }}
                      </option>
                    </BSelectWithValidation>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="3" class="title-form"> Desa/Kelurahan </b-col>
                  <b-col sm="9">
                    <BSelectWithValidation
                      v-model="form.data.kode_desa"
                      name="Pilih Desa/Kelurahan"
                    >
                      <option value="">Pilih Desa/Kelurahan</option>
                      <option
                        v-for="item in desaKelurahans"
                        :value="item.kode_desa"
                        v-bind:key="item.kode_desa"
                      >
                        {{ item.nama_desa }}
                      </option>
                    </BSelectWithValidation>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="3" class="title-form">
                    Satuan Lingkungan Setempat
                  </b-col>
                  <b-col sm="9">
                    <BSelectWithValidation
                      v-model="form.data.kode_sls"
                      name="Provinsi"
                    >
                      <option value="">Pilih Satuan Lingkungan Setempat</option>
                      <option
                        v-for="item in satuanLingkunganSetempats"
                        :value="item.kode_sls"
                        v-bind:key="item.kode_sls"
                      >
                        {{ item.nama_sls }}
                      </option>
                    </BSelectWithValidation>
                  </b-col>
                </b-row>
                <b-button
                  variant="success"
                  class="float-right"
                  @click="simpan()"
                  >Simpan</b-button
                >
              </div>
              <div v-if="form.status_keberadaan == 4">
                <b-alert show variant="info"
                  >Isikan keterangan anggota keluarga meninggal.</b-alert
                >
                <b-row class="my-1">
                  <b-col sm="3" class="title-form"> Tanggal Meninggal </b-col>
                  <b-col sm="9">
                    <BDatePickerWithValidation
                      v-model="form.data.tanggal_meninggal"
                      rules="required"
                      name="Tanggal Meninggal"
                      placeholder="Isikan tanggal meninggal"
                    />
                  </b-col>
                </b-row>
                <b-button
                  variant="success"
                  class="float-right"
                  @click="simpan()"
                  >Simpan</b-button
                >
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <ValidationObserver v-slot="{ passes }">
        <b-modal size="xl" id="modal-form" :title="modalTitle" scrollable>
          <b-row class="my-1">
            <b-col sm="3" class="title-form"> Nama </b-col>
            <b-col sm="9">
              <BTextInputWithValidation
                rules="required"
                v-model="form.data.nama"
                name="Nama"
                placeholder="Isikan nama"
              />
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="3" class="title-form"> Nomor Induk Kependudukan </b-col>
            <b-col sm="9">
              <BTextInputWithValidation
                rules="required|digits:16"
                type="number"
                v-model="form.data.nik"
                name="Nomor Induk Kependudukan"
                label=""
                placeholder="Isikan nomor induk kependudukan"
              />
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="3" class="title-form"> Nomor Kartu Keluarga </b-col>
            <b-col sm="9">
              <BTextInputWithValidation
                rules="required|digits:16"
                v-model="form.data.nomor_kk_baru"
                type="number"
                name="Nomor Kartu Keluarga"
                placeholder="Isikan nomor kartu keluarga"
              />
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="3" class="title-form"> Jenis Kelamin </b-col>
            <b-col sm="9">
              <BRadioWithValidation
                rules="required"
                v-model="form.data.jenis_kelamin"
                name="Jenis Kelamin"
                placeholder="Isikan jenis kelamin"
              >
                <b-form-radio value="L">Laki-laki</b-form-radio>
                <b-form-radio value="P">Perempuan</b-form-radio>
              </BRadioWithValidation>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="3" class="title-form"> Tanggal Lahir </b-col>
            <b-col sm="9">
              <BDatePickerWithValidation
                rules="required"
                v-model="form.data.tanggal_lahir"
                name="Tanggal Lahir"
                placeholder="Isikan tanggal lahir"
              />
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="3" class="title-form"> Agama </b-col>
            <b-col sm="9">
              <BSelectWithValidation
                rules="required"
                v-model="form.data.agama"
                name="Agama"
                placeholder="Isikan agama"
              >
                <option value="">Pilih Agama</option>
                <option value="1">Islam</option>
                <option value="2">Kristen</option>
                <option value="3">Katholik</option>
                <option value="4">Hindu</option>
                <option value="5">Budha</option>
                <option value="6">Konghuchu</option>
                <option value="7">Aliran Kepercayaan</option>
              </BSelectWithValidation>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="3" class="title-form"> Pendidikan Terakhir </b-col>
            <b-col sm="9">
              <BSelectWithValidation
                rules="required"
                v-model="form.data.pendidikan"
                name="Pendidikan Terakhir"
                placeholder="Isikan pendidikan terakhir"
              >
                <option value="">Pilih Pendidikan Terakhir</option>
                <option value="1">Tidak/Belum Sekolah</option>
                <option value="2">Belum Tamat SD/Sederajat</option>
                <option value="3">Tamat SD/Sederajat</option>
                <option value="4">SLTP/Sederajat</option>
                <option value="5">SLTA/Sederajat</option>
                <option value="6">Diploma I/II</option>
                <option value="7">Akademi/Diploma III/Sarjana Muda</option>
                <option value="8">Diploma IV/Strata I</option>
                <option value="9">Strata II</option>
                <option value="10">Strata III</option>
              </BSelectWithValidation>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="3" class="title-form"> Pekerjaan </b-col>
            <b-col sm="9">
              <BTextInputWithValidation
                rules="required"
                v-model="form.data.pekerjaan"
                name="Pekerjaan"
                placeholder="Isikan pekerjaan"
              />
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="3" class="title-form"> Status Pernikahan </b-col>
            <b-col sm="9">
              <BRadioWithValidation
                rules="required"
                v-model="form.data.status_kawin"
                name="Status Pernikahan"
                placeholder="Isikan status pernikahan ground check"
              >
                <b-form-radio value="1">Belum Kawin</b-form-radio>
                <b-form-radio value="2">Kawin</b-form-radio>
                <b-form-radio value="3">Cerai Hidup</b-form-radio>
                <b-form-radio value="4">Cerai Mati</b-form-radio>
              </BRadioWithValidation>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="3" class="title-form">
              Status Hungan Dengan Keluarga
            </b-col>
            <b-col sm="9">
              <BSelectWithValidation
                rules="required"
                v-model="form.data.status_hubungan_keluarga"
                name="Status Hubungan Dalam Keluarga"
                placeholder="Isikan status hubungan dalam keluarga"
              >
                <option value="">Pilih Status Hubungan Dalam Keluarga</option>
                <option value="1">Kepala Keluarga</option>
                <option value="2">Suami</option>
                <option value="3">Istri</option>
                <option value="4">Anak</option>
                <option value="5">Orang Tua</option>
                <option value="6">Mertua</option>
                <option value="7">Menantu</option>
                <option value="8">Cucu</option>
                <option value="9">Pembantu</option>
                <option value="10">Famili Lain</option>
                <option value="11">Lainnya</option>
              </BSelectWithValidation>
            </b-col>
          </b-row>
          <template v-slot:modal-footer>
            <div class="w-100">
              <b-button
                v-if="modalButton == 'ubah'"
                type="submit"
                variant="warning"
                size="sm"
                class="float-right"
                @click="passes(ubahTambahan)"
              >
                Ubah
              </b-button>
              <b-button
                v-else
                type="submit"
                variant="primary"
                size="sm"
                class="float-right"
                @click="passes(simpanTambahan)"
              >
                Tambah
              </b-button>
            </div>
          </template>
        </b-modal>
      </ValidationObserver>
    </b-container>
  </b-container>
</template>
<script>
import master from "../Master.js";
import titlePage from "@/components/Title";
import dataKonfirmasiService from "../../../services/sdpi/DataKonfirmasiService";
import dataHistoryService from "../../../services/sdpi/DataHistoryService";
import dataTambahanService from "../../../services/sdpi/DataTambahanService";
import masterWilayahService from "../../../services/sdpi/MasterWilayahAllService";
import BSelectWithValidation from "@/components/inputs/BSelectWithValidation";
import BTextInputWithValidation from "@/components/inputs/BTextInputWithValidation";
import BDatePickerWithValidation from "@/components/inputs/BDatePickerWithValidation";
import BRadioWithValidation from "@/components/inputs/BRadioWithValidation";
import { ValidationObserver } from "vee-validate";
export default {
  components: {
    titlePage,
    ValidationObserver,
    BSelectWithValidation,
    BTextInputWithValidation,
    BRadioWithValidation,
    BDatePickerWithValidation,
  },
  data: () => {
    return {
      breadcrumbs: [
        {
          text: "Beranda",
          to: "/sdpi",
        },
        {
          text: "Konfirmasi",
          to: "/sdpi/konfirmasi",
        },
        {
          text: "Entri Konfirmasi",
          active: true,
        }
      ],
      masters: {},
      datas: [],
      tambahanDatas: [],
      dataHistorys: [],
      fields: [
        "no",
        {
          label: "NIK",
          key: "nik",
        },
        {
          label: "Nama",
          key: "nama",
          thStyle: { minWidth: "200px" },
        },
        {
          label: "Jenis Kelamin",
          key: "jenis_kelamin",
        },
        {
          label: "Status Hubungan Keluarga",
          key: "status_hubungan_keluarga",
        },
        {
          label: "Jumlah Anomali",
          key: "jumlah_anomali",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          key: "aksi",
          label: "Aksi",
          thStyle: { minWidth: "85px" },
          tdClass: "text-center",
        },
      ],
      tambahanFields: [
        "no",
        {
          label: "Nama",
          key: "nama",
          thStyle: { minWidth: "200px" },
        },
        {
          label: "NIK",
          key: "nik",
        },
        {
          label: "Nomor KK",
          key: "nomor_kk_baru",
          thStyle: { minWidth: "100px" },
        },
        {
          label: "Jenis Kelamin",
          key: "jenis_kelamin",
          thStyle: { minWidth: "150px" },
        },
        {
          label: "Tanggal Lahir",
          key: "tanggal_lahir",
          thStyle: { minWidth: "135px" },
        },
        {
          label: "Agama",
          key: "agama",
        },
        {
          label: "Pendidikan",
          key: "pendidikan",
          thStyle: { minWidth: "200px" },
        },
        {
          label: "Jenis Pekerjaan",
          key: "pekerjaan",
          thStyle: { minWidth: "200px" },
        },
        {
          label: "Status Pernikahan",
          key: "status_kawin",
          thStyle: { minWidth: "200px" },
        },
        {
          label: "Status Hubungan Keluarga",
          key: "status_hubungan_keluarga",
          thStyle: { minWidth: "250px" },
        },
        {
          key: "aksi",
          label: "Aksi",
          thStyle: { minWidth: "150px" },
          tdClass: "text-center",
        },
      ],
      itemSelected: null,
      form: {
        status_keberadaan: "",
        nama: 0,
        nik: 0,
        nomor_kk: 0,
        jenis_kelamin: 0,
        tanggal_lahir: 0,
        agama: 0,
        pendidikan: 0,
        pekerjaan: 0,
        status_kawin: 0,
        status_hubungan_keluarga: 0,
        kewarganegaraan: 0,
        data: {
          nama: null,
          nik: null,
          nomor_kk: null,
          jenis_kelamin: null,
          tanggal_lahir: null,
          agama: null,
          pendidikan: null,
          pekerjaan: null,
          status_kawin: null,
          status_hubungan_keluarga: null,
          kewarganegaraan: null,
          kode_prov: null,
          kode_kab: null,
          kode_kec: null,
          kode_desa: null,
          kode_sls: null,
        },
      },
      provinsis: [],
      kabupatenKotas: [],
      kecamatans: [],
      desaKelurahans: [],
      satuanLingkunganSetempats: [],
      modalTitle: "",
      modalButton: "",
      konfirmasiButton: "",
      idDataTambahan: null,
      nomor_kk:null
    };
  },
  methods: {
    async getDatas() {
      await dataKonfirmasiService
        .getDataKonfirmasiSearchByKodeSlsAndNama(this.$route.params.kode_sls, this.$route.params.nama)
        .then(
          (result) => {
            this.datas = result.data.data;
            this.nomor_kk = this.datas[0].id
            this.getTambahanDatas();
          },

          (error) => {
            console.log(error);
          }
        );
    },
    async getTambahanDatas() {
      await dataTambahanService
        .getDataHistorySearch(null, this.nomor_kk)
        .then(
          (result) => {
            console.log(this.nomor_kk)
            this.tambahanDatas = result.data.data;
            this.getDataHistorys()
          },

          (error) => {
            console.log(error);
          }
        );
    },
    async getDataHistorys() {
      await dataHistoryService
        .getDataHistorySearch(null, this.nomor_kk)
        .then(
          (result) => {
            this.dataHistorys = result.data.data;
          },

          (error) => {
            console.log(error);
          }
        );
    },
    async postData(data) {
      await dataHistoryService.postData(data).then(
        () => {
          alert("Data Berhasil Disimpan");
          this.form.status_keberadaan = "";
          this.itemSelected = null;
          this.getDataHistorys();
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async postTambahanData(data) {
      await dataTambahanService.postData(data).then(
        () => {
          alert("Data Berhasil Disimpan");
          this.$bvModal.hide("modal-form");
          this.getTambahanDatas();
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async putData(data) {
      await dataHistoryService.putData(data).then(
        () => {
          alert("Data Berhasil Diubah");
          this.form.status_keberadaan = "";
          this.itemSelected = null;
          this.getDataHistorys();
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async putTambahanData(data) {
      await dataTambahanService.putData(data).then(
        () => {
          alert("Data Berhasil Diubah");
          this.$bvModal.hide("modal-form");
          this.getTambahanDatas();
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async deleteTambahanData(data) {
      await dataTambahanService.deleteData(data).then(
        () => {
          alert("Data Berhasil Dihapus");
          this.getTambahanDatas();
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async deleteHistoryData(nomor_kk) {
      let data = {
        id: this.dataHistorys.filter((x) => x.nomor_kk == nomor_kk)[0].id,
      };
      await dataHistoryService.deleteData(data).then(
        () => {
          alert("Data Berhasil Dihapus");
          this.getDataHistorys();
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getProvinsi() {
      await masterWilayahService.getProvinsi().then(
        (result) => {
          this.provinsis = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getKabupatenKota(id) {
      await masterWilayahService.getKabupatenKotaByProvinsi(id).then(
        (result) => {
          this.kabupatenKotas = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getKecamatan(id) {
      await masterWilayahService.getKecamatanByKabupatenKota(id).then(
        (result) => {
          this.kecamatans = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getDesaKelurahan(id) {
      await masterWilayahService.getDesaKelurahanByKecamatan(id).then(
        (result) => {
          this.desaKelurahans = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getSls(id) {
      await masterWilayahService.getSlsByDesa(id).then(
        (result) => {
          this.satuanLingkunganSetempats = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    showModal(id, item) {
      if (id == 2) {
        this.modalTitle = "Ubah Anggota Keluarga Baru";
        this.modalButton = "ubah";
        this.form.data = item;
      } else {
        this.form.data = {
          nama: null,
          nik: null,
          nomor_kk: null,
          jenis_kelamin: null,
          tanggal_lahir: null,
          agama: null,
          pendidikan: null,
          pekerjaan: null,
          status_kawin: null,
          status_hubungan_keluarga: null,
          kewarganegaraan: null,
          kode_prov: null,
          kode_kab: null,
          kode_kec: null,
          kode_desa: null,
          kode_sls: null,
        };
        this.modalButton = "tambah";
        this.modalTitle = "Tambah Anggota Keluarga Baru";
      }
      this.form.status_keberadaan = "";
      this.itemSelected = null;
      this.$bvModal.show("modal-form");
    },
    countAnomali(item) {
      let total = 0;
      if (item.rule1 == 1) {
        total += 1;
      }
      if (item.rule2 == 1) {
        total += 1;
      }
      if (item.rule3 == 1) {
        total += 1;
      }
      if (item.rule4 == 1) {
        total += 1;
      }
      if (item.rule5 == 1) {
        total += 1;
      }
      if (item.rule6 == 1) {
        total += 1;
      }
      if (item.rule7 == 1) {
        total += 1;
      }
      return total;
    },
    konfirmasi(id, item) {
      const el = this.$el.querySelector("#div-form");
      if (el) {
        el.scrollIntoView();
      }
      this.itemSelected = item;
      this.konfirmasiButton = "tambah";
      this.form = {
        status_keberadaan: "",
        nama: 0,
        nik: 0,
        nomor_kk: 0,
        jenis_kelamin: 0,
        tanggal_lahir: 0,
        agama: 0,
        pendidikan: 0,
        pekerjaan: 0,
        status_kawin: 0,
        status_hubungan_keluarga: 0,
        kewarganegaraan: 0,
        data: {
          nama: null,
          nik: null,
          nomor_kk: null,
          jenis_kelamin: null,
          tanggal_lahir: null,
          agama: null,
          pendidikan: null,
          pekerjaan: null,
          status_kawin: null,
          status_hubungan_keluarga: null,
          kewarganegaraan: null,
          kode_prov: null,
          kode_kab: null,
          kode_kec: null,
          kode_desa: null,
          kode_sls: null,
        },
      };
      if (id === 2) {
        this.konfirmasiButton = "ubah";
        let data = this.dataHistorys.filter((x) => x.nomor_kk == item.id);
        this.form = {
          status_keberadaan: data[0].status_keberadaan,
          nama: data[0].nama == null ? 1 : 0,
          nik: data[0].nik_baru == null ? 1 : 0,
          nomor_kk: data[0].nomor_kk_baru == null ? 1 : 0,
          jenis_kelamin: data[0].jenis_kelamin == null ? 1 : 0,
          tanggal_lahir: data[0].tanggal_lahir == null ? 1 : 0,
          agama: data[0].agama == null ? 1 : 0,
          pendidikan: data[0].pendidikan == null ? 1 : 0,
          pekerjaan: data[0].pekerjaan == null ? 1 : 0,
          status_kawin: data[0].status_kawin == null ? 1 : 0,
          status_hubungan_keluarga:
            data[0].status_hubungan_keluarga == null ? 1 : 0,
          kewarganegaraan: data[0].kewarganegaraan == null ? 1 : 0,
          data: {
            id: data[0].id,
            nama: data[0].nama != null ? data[0].nama : null,
            nik: data[0].nik_baru != null ? data[0].nik_baru : null,
            nomor_kk:
              data[0].nomor_kk_baru != null ? data[0].nomor_kk_baru : null,
            jenis_kelamin:
              data[0].jenis_kelamin != null ? data[0].jenis_kelamin : null,
            tanggal_lahir:
              data[0].tanggal_lahir != null ? data[0].tanggal_lahir : null,
            agama: data[0].agama != null ? data[0].agama : null,
            pendidikan: data[0].pendidikan != null ? data[0].pendidikan : null,
            pekerjaan: data[0].pekerjaan != null ? data[0].pekerjaan : null,
            status_kawin:
              data[0].status_kawin != null ? data[0].status_kawin : null,
            status_hubungan_keluarga:
              data[0].status_hubungan_keluarga != null
                ? data[0].status_hubungan_keluarga
                : null,
            kewarganegaraan:
              data[0].kewarganegaraan != null ? data[0].kewarganegaraan : null,
            kode_prov:
              data[0].kode_prov_baru != null ? data[0].kode_prov_baru : null,
            kode_kab:
              data[0].kode_kab_baru != null ? data[0].kode_kab_baru : null,
            kode_kec:
              data[0].kode_kec_baru != null ? data[0].kode_kec_baru : null,
            kode_desa:
              data[0].kode_desa_baru != null ? data[0].kode_desa_baru : null,
            kode_sls:
              data[0].kode_sls_baru != null ? data[0].kode_sls_baru : null,
          },
        };
      }
    },
    cekHistory(nomor_kk) {
      return this.dataHistorys.filter((x) => x.nomor_kk == nomor_kk).length == 0
        ? "Belum Dikonfirmasi"
        : "Sudah Dikonfirmasi";
    },
    simpan() {
      let data = {
        status_keberadaan: this.form.status_keberadaan,
        nama: this.form.data.nama,
        kode_prov: this.itemSelected.kode_prov,
        kode_kab: this.itemSelected.kode_kab,
        kode_kec: this.itemSelected.kode_kec,
        kode_desa: this.itemSelected.kode_desa,
        kode_sls: this.itemSelected.kode_sls,
        nik: this.itemSelected.nik==null?this.itemSelected.id:this.itemSelected.nik,
        nik_baru: this.form.data.nik,
        nomor_kk: this.itemSelected.nomor_kk==null?this.itemSelected.id:this.itemSelected.nomor_kk,
        nomor_kk_baru: this.form.data.nomor_kk,
        jenis_kelamin: this.form.data.jenis_kelamin,
        tanggal_lahir: this.form.data.tanggal_lahir,
        agama: this.form.data.agama,
        pendidikan: this.form.data.pendidikan,
        pekerjaan: this.form.data.pekerjaan,
        status_kawin: this.form.data.status_kawin,
        status_hubungan_keluarga: this.form.data.status_hubungan_keluarga,
        kewarganegaraan: this.form.data.kewarganegaraan,
        kode_prov_baru: this.form.data.kode_prov,
        kode_kab_baru: this.form.data.kode_kab,
        kode_kec_baru: this.form.data.kode_kec,
        kode_desa_baru: this.form.data.kode_desa,
        kode_sls_baru: this.form.data.kode_sls,
        tanggal_meninggal: this.form.data.tanggal_meninggal,
      };
      this.postData(data);
    },
    ubah() {
      let data = {
        id: this.form.data.id,
        status_keberadaan: this.form.status_keberadaan,
        nama: this.form.data.nama,
        kode_prov: this.itemSelected.kode_prov,
        kode_kab: this.itemSelected.kode_kab,
        kode_kec: this.itemSelected.kode_kec,
        kode_desa: this.itemSelected.kode_desa,
        kode_sls: this.itemSelected.kode_sls,
        nik: this.itemSelected.nik==null?this.itemSelected.id:this.itemSelected.nik,
        nik_baru: this.form.data.nik,
        nomor_kk: this.itemSelected.nomor_kk==null?this.itemSelected.id:this.itemSelected.nomor_kk,
        nomor_kk_baru: this.form.data.nomor_kk,
        jenis_kelamin: this.form.data.jenis_kelamin,
        tanggal_lahir: this.form.data.tanggal_lahir,
        agama: this.form.data.agama,
        pendidikan: this.form.data.pendidikan,
        pekerjaan: this.form.data.pekerjaan,
        status_kawin: this.form.data.status_kawin,
        status_hubungan_keluarga: this.form.data.status_hubungan_keluarga,
        kewarganegaraan: this.form.data.kewarganegaraan,
        kode_prov_baru: this.form.data.kode_prov,
        kode_kab_baru: this.form.data.kode_kab,
        kode_kec_baru: this.form.data.kode_kec,
        kode_desa_baru: this.form.data.kode_desa,
        kode_sls_baru: this.form.data.kode_sls,
        tanggal_meninggal: this.form.data.tanggal_meninggal,
      };
      this.putData(data);
    },
    simpanTambahan() {
      let data = {
        kode_prov: this.datas[0].kode_prov,
        kode_kab: this.datas[0].kode_kab,
        kode_kec: this.datas[0].kode_kec,
        kode_desa: this.datas[0].kode_desa,
        kode_sls: this.datas[0].kode_sls,
        nama: this.form.data.nama,
        nik: this.form.data.nik,
        nomor_kk: this.datas[0].nomor_kk==null?this.datas[0].id:this.datas[0].nomor_kk,
        nomor_kk_baru: this.form.data.nomor_kk_baru,
        jenis_kelamin: this.form.data.jenis_kelamin,
        tanggal_lahir: this.form.data.tanggal_lahir,
        agama: this.form.data.agama,
        pendidikan: this.form.data.pendidikan,
        pekerjaan: this.form.data.pekerjaan,
        status_kawin: this.form.data.status_kawin,
        status_hubungan_keluarga: this.form.data.status_hubungan_keluarga,
      };
      this.postTambahanData(data);
    },
    ubahTambahan() {
      let data = {
        id: this.form.data.id,
        kode_prov: this.datas[0].kode_prov,
        kode_kab: this.datas[0].kode_kab,
        kode_kec: this.datas[0].kode_kec,
        kode_desa: this.datas[0].kode_desa,
        kode_sls: this.datas[0].kode_sls,
        nama: this.form.data.nama,
        nik: this.form.data.nik,
        nomor_kk: this.datas[0].nomor_kk,
        nomor_kk_baru: this.form.data.nomor_kk_baru,
        jenis_kelamin: this.form.data.jenis_kelamin,
        tanggal_lahir: this.form.data.tanggal_lahir,
        agama: this.form.data.agama,
        pendidikan: this.form.data.pendidikan,
        pekerjaan: this.form.data.pekerjaan,
        status_kawin: this.form.data.status_kawin,
        status_hubungan_keluarga: this.form.data.status_hubungan_keluarga,
      };
      this.putTambahanData(data);
    },
  },
  mounted() {
    this.masters = master;
    this.getDatas();
    this.getProvinsi();
  },
  watch: {
    "form.status_keberadaan"(val) {
      if (val == 1) {
        this.form.data.kode_prov = null;
        this.form.data.kode_kab = null;
        this.form.data.kode_kec = null;
        this.form.data.kode_desa = null;
        this.form.data.kode_sls = null;
        this.form.data.tanggal_meninggal = null;
      } else if (val == 3) {
        this.form.data.nama = null;
        this.form.data.nik = null;
        this.form.data.nomor_kk = null;
        this.form.data.jenis_kelamin = null;
        this.form.data.tanggal_lahir = null;
        this.form.data.agama = null;
        this.form.data.pendidikan = null;
        this.form.data.pekerjaan = null;
        this.form.data.status_kawin = null;
        this.form.data.status_hubungan_keluarga = null;
        this.form.data.kewarganegaraan = null;
        this.form.data.tanggal_meninggal = null;
      } else if (val == 4) {
        this.form.data.kode_prov = null;
        this.form.data.kode_kab = null;
        this.form.data.kode_kec = null;
        this.form.data.kode_desa = null;
        this.form.data.kode_sls = null;
        this.form.data.nama = null;
        this.form.data.nik = null;
        this.form.data.nomor_kk = null;
        this.form.data.jenis_kelamin = null;
        this.form.data.tanggal_lahir = null;
        this.form.data.agama = null;
        this.form.data.pendidikan = null;
        this.form.data.pekerjaan = null;
        this.form.data.status_kawin = null;
        this.form.data.status_hubungan_keluarga = null;
        this.form.data.kewarganegaraan = null;
      } else {
        this.form.data.kode_prov = null;
        this.form.data.kode_kab = null;
        this.form.data.kode_kec = null;
        this.form.data.kode_desa = null;
        this.form.data.kode_sls = null;
        this.form.data.nama = null;
        this.form.data.nik = null;
        this.form.data.nomor_kk = null;
        this.form.data.jenis_kelamin = null;
        this.form.data.tanggal_lahir = null;
        this.form.data.agama = null;
        this.form.data.pendidikan = null;
        this.form.data.pekerjaan = null;
        this.form.data.status_kawin = null;
        this.form.data.status_hubungan_keluarga = null;
        this.form.data.kewarganegaraan = null;
        this.form.data.tanggal_meninggal = null;
      }
    },
    "form.nama"() {
      this.form.data.nama = null;
    },
    "form.nik"() {
      this.form.data.nik = null;
    },
    "form.nomor_kk"() {
      this.form.data.nomor_kk = null;
    },
    "form.jenis_kelamin"() {
      this.form.data.jenis_kelamin = null;
    },
    "form.tanggal_lahir"() {
      this.form.data.tanggal_lahir = null;
    },
    "form.agama"() {
      this.form.data.agama = null;
    },
    "form.pendidikan"() {
      this.form.data.pendidikan = null;
    },
    "form.pekerjaan"() {
      this.form.data.pekerjaan = null;
    },
    "form.status_kawin"() {
      this.form.data.status_kawin = null;
    },
    "form.status_hubungan_keluarga"() {
      this.form.data.status_hubungan_keluarga = null;
    },
    "form.kewarganegaraan"() {
      this.form.data.kewarganegaraan = null;
    },
    "form.data.kode_prov"(val) {
      if (val) {
        this.form.data.kode_kab = null;
        this.form.data.kode_kec = null;
        this.form.data.kode_desa = null;
        this.param = "kode_prov=" + val;
        this.getKabupatenKota(val);
      }
    },
    "form.data.kode_kab"(val) {
      if (val) {
        this.form.data.kode_kec = null;
        this.form.data.kode_desa = null;
        this.getKecamatan(val);
      }
    },
    "form.data.kode_kec"(val) {
      if (val) {
        this.form.data.kode_desa = null;
        this.getDesaKelurahan(val);
      }
    },
    "form.data.kode_desa"(val) {
      if (val) {
        this.getSls(val);
      }
    },
  },
};
</script>
